'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Field, FieldLabel } from '@achra/ui/field';
import { Input } from '@achra/ui/input';
import { cn } from '@achra/ui/lib/utils';
import { useActionState, useEffect } from 'react';
import { submitWhitelistEmailAction } from '@/modules/whitelist/actions/whitelist-action';
import type { WhitelistFormState } from '@/modules/whitelist/types';
import { JoinedUsersBadge } from '../joined-users-badge';
const initialState: WhitelistFormState = {
  success: false
};
interface WhitelistFormProps {
  onSuccess: () => void;
}
function WhitelistForm(t0) {
  const $ = _c(30);
  const {
    onSuccess
  } = t0;
  const [state, formAction, isPending] = useActionState(submitWhitelistEmailAction, initialState);
  let t1;
  let t2;
  if ($[0] !== onSuccess || $[1] !== state.success) {
    t1 = () => {
      if (state.success) {
        onSuccess();
      }
    };
    t2 = [state.success, onSuccess];
    $[0] = onSuccess;
    $[1] = state.success;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="relative z-20 py-2 text-center font-sans text-4xl font-semibold tracking-tighter md:py-10 md:text-8xl">Join the Waitlist</h2>;
    t4 = <p className="text-md text-muted-foreground mx-auto max-w-xl text-center lg:text-lg">Get early access to Achra, the operations marketplace for open networks. Scope work, choose providers, pay in stablecoins, and track results in one place.</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  const t5 = !!state.error;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FieldLabel htmlFor="whitelist-email" className="sr-only">Email Address</FieldLabel>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = !!state.error;
  const t8 = state.email ?? "";
  const t9 = state.email;
  const t10 = state.error && "ring-destructive/50 ring-2";
  let t11;
  if ($[7] !== t10) {
    t11 = cn("bg-muted h-10 w-full rounded-xl border-none shadow-none ring-0 focus-visible:ring-0 focus-visible:outline-none active:ring-0 active:outline-0", t10);
    $[7] = t10;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  let t12;
  if ($[9] !== isPending || $[10] !== state.email || $[11] !== t11 || $[12] !== t7 || $[13] !== t8) {
    t12 = <Input id="whitelist-email" name="email" type="email" aria-invalid={t7} placeholder="Enter your email" defaultValue={t8} key={t9} className={t11} disabled={isPending} required={true} />;
    $[9] = isPending;
    $[10] = state.email;
    $[11] = t11;
    $[12] = t7;
    $[13] = t8;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = isPending ? "Joining..." : "Join the Waitlist";
  let t14;
  if ($[15] !== isPending || $[16] !== t13) {
    t14 = <Button type="submit" className="h-10 rounded-xl" disabled={isPending}>{t13}</Button>;
    $[15] = isPending;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t12 || $[19] !== t14) {
    t15 = <div className="flex items-center gap-3 rounded-full p-1">{t12}{t14}</div>;
    $[18] = t12;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== state.error) {
    t16 = state.error && <div role="alert" className="text-destructive mt-2 px-1 text-sm font-normal">{state.error}</div>;
    $[21] = state.error;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t15 || $[24] !== t16 || $[25] !== t5) {
    t17 = <form action={formAction} className="relative z-20 mt-10 w-full max-w-md"><Field data-invalid={t5}>{t6}{t15}{t16}</Field></form>;
    $[23] = t15;
    $[24] = t16;
    $[25] = t5;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <JoinedUsersBadge />;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t17) {
    t19 = <>{t3}{t4}{t17}{t18}</>;
    $[28] = t17;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  return t19;
}
export { WhitelistForm };